import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.planting)?_c('span',[(_vm.small)?_c('span',{staticClass:"text-truncate product-text"},[_c('small',[_c(VAvatar,{staticClass:"mr-1",attrs:{"size":"14","color":_vm.planting.colorHex}}),_vm._v("\n      "+_vm._s(_vm.getDisplayText())+"\n    ")],1)]):_c('span',{staticClass:"text-truncate"},[_c(VAvatar,{staticClass:"mr-1",attrs:{"size":"24","color":_vm.planting.colorHex}}),_vm._v("\n    "+_vm._s(_vm.getDisplayText())+"\n  ")],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }